import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../lib/cn";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

/** Tooltip chrome for surfaces that can't render `TooltipContent`, e.g. a Recharts `content` element. */
const TOOLTIP_PANEL_CLASS =
  "rounded-md border border-[#0c0c0d14] bg-white text-neutral-900 shadow-[0_1px_2px_rgba(0,0,0,0.04),0_8px_24px_-6px_rgba(0,0,0,0.12)] dark:border-white/12 dark:bg-[#2A2C2C] dark:text-white dark:shadow-[0_1px_2px_rgba(0,0,0,0.2),0_8px_24px_-6px_rgba(0,0,0,0.4)]";

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    /** Portal target instead of `document.body`; a fullscreen element must host its own tooltips. */
    container?: HTMLElement | null;
  }
>(({ className, sideOffset = 4, container, ...props }, ref) => (
  <TooltipPrimitive.Portal container={container}>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        TOOLTIP_PANEL_CLASS,
        "font-sans z-50 overflow-hidden px-2 py-1 type-body-xs-regular animate-in fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 duration-150",
        className,
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TOOLTIP_PANEL_CLASS,
};
